<script>
  import AppContentLoader from '../../components/main/ContentLoader'

  import * as restfulService from '../../services/restfulService'

  import bus from '@utils/bus'

  // import {get, set} from '@utils/storage'

  import {mapGetters} from 'vuex'

  // const isNavigatorOnline = () => navigator.onLine || false

  export default {
    name: 'dashboard-horarios',
    components: {AppContentLoader},
    data () {
      return {
        carregandoDados: true,
        contratoAtivo: '',
        contratos: [],
        regimes: [
          {
            'id': '8',
            'name': 'Aula Extra'
          },
          {
            'id': '7',
            'name': 'Híbrido(Não presencial)'
          },
          {
            'id': '6',
            'name': 'Não presencial'
          },
          {
            'id': '4',
            'name': 'Orientação Trabalho de Conclusão'
          },
          {
            'id': '2',
            'name': 'Regime Especial'
          },
          {
            'id': '1',
            'name': 'Regime Normal(Sala de aula)'
          },
          {
            'id': '5',
            'name': 'Semipresencial'
          },
          {
            'id': '3',
            'name': 'Supervisão de Estágio'
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      listaContratosContagem: function () {
        return this.contratos.length
      }
    },
    async mounted () {
      this.buscarHorariosPeriodoAtivo()
    },
    methods: {
      getKeyStorageGradeHorarios () {
        return 'gradeHorarios' + this.currentUser.ref_pessoa
      },
      setaAbaContrato () {
        if (this.contratos.length) {
          this.contratoAtivo = 'tab-' + this.contratos[0].id
        }
      },
      buscarHorariosPeriodoAtivo () {
        this.carregandoDados = true
        this.contratos.splice(0)
        restfulService.get('dashboard', 'horarios')
          .then((response) => {
            if (response.length) {
              // set(this.getKeyStorageGradeHorarios(), response)
              this.contratos = [...this.contratos, ...response]
              this.setaAbaContrato()
            }
            setTimeout(() => {
              this.carregandoDados = false
            }, 300)
          })
          .catch(e => {
            this.carregandoDados = false
            console.log(e)
          })
      },
      logarMoodle (link) {
        bus.$emit('show-loader')
        restfulService.get('usuario', 'moodle-login')
          .then(response => {
            bus.$emit('hide-loader')
            window.open(response.url + '&wantsurl=' + link, '_blank')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="box box-75 has-loading">
        <app-content-loader :is-loading.sync="carregandoDados"/>
        <div class="box-header">
            <div class="box-title">Horários</div>
            <div class="box-nav">
                <div class="box-icon" @click="buscarHorariosPeriodoAtivo()" title="Recarregar Dados">
                    <i class="fas fa-sync"></i>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-vazio" v-if="listaContratosContagem === 0">
                <div>
                    <div class="icon-vazio"><i class="fas fa-graduation-cap"></i></div>
                    <h3>Você não possui cursos ativos</h3>
                </div>
            </div>
            <div class="box-content-full">
                <v-tabs fixed-tabs
                        slot="extension"
                        v-model="contratoAtivo"
                        v-if="listaContratosContagem > 1"
                        slider-color="orange darken-3">
                    <v-tab v-for="contrato in contratos"
                           :href="`#tab-${contrato.id}`">
                        {{contrato.descricao}}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="contratoAtivo" v-if="listaContratosContagem > 0">
                    <v-tab-item v-for="contrato in contratos"
                                :id="`tab-${contrato.id}`">
                        <div class="responsive-table">
                            <table class="dashboard-table">
                                <thead>
                                <tr>
                                    <th align="center" class="horario">Horário</th>
                                    <th>Segunda-Feira</th>
                                    <th>Terça-Feira</th>
                                    <th>Quarta-Feira</th>
                                    <th>Quinta-Feira</th>
                                    <th>Sexta-Feira</th>
                                    <th>Sábado</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in contrato.horarios">
                                    <td align="center" class="horario"><strong>{{item.hora}}</strong></td>
                                    <td>
                                      <span>{{item['2'] ? item['2'].disciplina : ''}} </span>
                                      <a
                                        class="pl-2" v-if="item['2'] && item['2'].moodle"
                                        @click="logarMoodle(item['2'].moodle)"><i title="Ambiente virtual"
                                        class="fas fa-laptop"></i>
                                      </a>
                                      <a class="pl-2"
                                         v-if="item['2'] && item['2'].link_video_conferencia"
                                         :href="item['2'].link_video_conferencia"
                                         target="_blank">
                                        <i title="Link p/ Vídeo Conferência"
                                           class="fas fa-video"></i>
                                      </a>
                                    </td>
                                    <td>
                                      <span>{{item['3'] ? item['3'].disciplina : ''}}</span>
                                      <a
                                        class="pl-2" target="_blank" v-if="item['3'] && item['3'].moodle"
                                        @click="logarMoodle(item['3'].moodle)"><i title="Ambiente virtual"
                                        class="fas fa-laptop"></i>
                                      </a>
                                      <a class="pl-2"
                                         v-if="item['3'] && item['3'].link_video_conferencia"
                                         :href="item['3'].link_video_conferencia"
                                         target="_blank">
                                        <i title="Link p/ Vídeo Conferência"
                                           class="fas fa-video"></i>
                                      </a>
                                    </td>
                                    <td>
                                      <span>{{item['4'] ? item['4'].disciplina : ''}}</span>
                                      <a
                                        class="pl-2" target="_blank" v-if="item['4'] && item['4'].moodle"
                                        @click="logarMoodle(item['4'].moodle)"><i title="Ambiente virtual"
                                        class="fas fa-laptop"></i>
                                      </a>
                                      <a class="pl-2"
                                         v-if="item['4'] && item['4'].link_video_conferencia"
                                         :href="item['4'].link_video_conferencia"
                                         target="_blank">
                                        <i title="Link p/ Vídeo Conferência"
                                           class="fas fa-video"></i>
                                      </a>
                                    </td>
                                    <td>
                                      <span>{{item['5'] ? item['5'].disciplina : ''}}</span><a
                                        class="pl-2" target="_blank" v-if="item['5'] && item['5'].moodle"
                                        @click="logarMoodle(item['5'].moodle)"><i title="Ambiente virtual"
                                        class="fas fa-laptop"></i>
                                      </a>
                                      <a class="pl-2"
                                         v-if="item['5'] && item['5'].link_video_conferencia"
                                         :href="item['5'].link_video_conferencia"
                                         target="_blank">
                                        <i title="Link p/ Vídeo Conferência"
                                           class="fas fa-video"></i>
                                      </a>
                                    </td>
                                    <td>
                                      <span>{{item['6'] ? item['6'].disciplina : ''}}</span>
                                      <a
                                        class="pl-2" target="_blank" v-if="item['6'] && item['6'].moodle"
                                        @click="logarMoodle(item['6'].moodle)"><i title="Ambiente virtual"
                                         class="fas fa-laptop"></i>
                                      </a>
                                      <a class="pl-2"
                                         v-if="item['6'] && item['6'].link_video_conferencia"
                                         :href="item['6'].link_video_conferencia"
                                         target="_blank">
                                        <i title="Link p/ Vídeo Conferência"
                                           class="fas fa-video"></i>
                                      </a>
                                    </td>
                                    <td>
                                      <span>{{item['7'] ? item['7'].disciplina : ''}}</span>
                                      <a
                                        class="pl-2" target="_blank" v-if="item['7'] && item['7'].moodle"
                                        @click="logarMoodle(item['7'].moodle)">
                                        <i title="Ambiente virtual"
                                        class="fas fa-laptop"></i>
                                      </a>
                                      <a class="pl-2"
                                         v-if="item['7'] && item['7'].link_video_conferencia"
                                         :href="item['7'].link_video_conferencia"
                                         target="_blank">
                                        <i title="Link p/ Vídeo Conferência"
                                           class="fas fa-video"></i>
                                      </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </div>
    </div>
</template>
<style>
    .lista-regimes .v-list__tile {
        height: 25px;
    }

    .regime_1, .regime_2, .regime_3, .regime_4, .regime_5, .regime_6, .regime_7, .regime_8 {
        margin-right: 5px;
    }

    .regime_1 {
        color: green;

    }

    .regime_2 {
        color: yellow;
    }

    .regime_3 {
        color: gray;
    }

    .regime_4 {
        color: pink;
    }

    .regime_5 {
        color: purple;
    }

    .regime_6 {
        color: orange;
    }

    .regime_7 {
        color: red;
    }

    .regime_8 {
        color: blue;
    }

</style>



// WEBPACK FOOTER //
// Horarios.vue?175df467